<template>
  <section name="home">
    <HeaderButtons
        :options="{
          showCreateBtn: false, 
          showBackBtn:true,
          mode: 'view'
        }"
        @goBack="goBack"
      />
    <div
      :class="{
        'container wide--container main--container': true,
        'side--open': $store.getters.isSideOpen(),
        loaded: loaded,
      }"
    >
      <div v-if="trainingGroup.trainings != ''">
        <h1 class="title-bar">
          <!-- {{ trainingGroup.name != undefined ? trainingGroup.name : "" }} -->
        </h1>
        <div class="cards">
          <div
            v-for="(training, trainingIndex) in trainingGroup.trainings"
            :key="`training-${trainingGroup.id}-${trainingIndex}`"
            :class="['card', training.ended ? 'ended' : '', training.purchased ? 'fade' : $store.state.user_role == 'user' && training.rented && !training.ended ? 'fade' : '']"
            v-show="training.enabled != 0"
            :style="getCardStyle(training)"
          >
            <div class="tag-container">
              <span v-if="training.purchased" class="white">
                {{toLocal('training_shop.purchased')}}
                <svg                  width="28"                  height="20"                  viewBox="0 0 28 20"                  fill="none"                  xmlns="http://www.w3.org/2000/svg"                >                  <g clip-path="url(#clip0_1014_216)">                    <path                      d="M27.4815 4.56842L23.5096 0.526316C23.1778 0.189474 22.7319 0 22.2652 0H19.88C19.4133 0 18.9674 0.147368 18.5837 0.410526H16.043C15.2859 0.410526 14.5496 0.631579 13.9067 1.03158C13.3052 1.41053 12.8178 1.93684 12.4859 2.56842C12.1437 1.93684 11.6563 1.41053 11.0652 1.03158C10.4222 0.631579 9.67556 0.410526 8.92889 0.410526H2.14667C1.87704 0.410526 1.65926 0.642105 1.65926 0.905263V16.8947C1.65926 17.1684 1.87704 17.3895 2.14667 17.3895H7.02074C8.70074 17.3895 10.36 17.8526 11.8119 18.7368C11.6667 18.9158 11.4489 19.0105 11.2311 19.0105C11.1793 19.0105 11.1274 19 11.0652 18.9895C8.47259 18.3789 5.81778 18.0737 3.15259 18.0737H0.985185V3.02105C0.985185 2.74737 0.757037 2.51579 0.487407 2.51579C0.217778 2.51579 0 2.74737 0 3.02105V18.5789C0 18.8526 0.228148 19.0737 0.487407 19.0737H3.15259C5.74518 19.0737 8.32741 19.3684 10.8474 19.9579C10.9822 19.9895 11.1067 20 11.2415 20C11.7185 20 12.1644 19.8105 12.4859 19.4632C12.8074 19.8105 13.2533 20 13.72 20C13.8548 20 13.9793 19.9895 14.1141 19.9579C16.6444 19.3684 19.2267 19.0632 21.8089 19.0632H24.4741C24.7437 19.0632 24.9615 18.8421 24.9615 18.5684V9.67368L27.4815 7.10526C27.8237 6.76842 28 6.31579 28 5.84211C28 5.36842 27.8237 4.90526 27.4815 4.56842ZM11.9881 17.6842C10.4637 16.8316 8.76296 16.3895 7.03111 16.3895H2.63407V1.41053H8.91852C10.6193 1.42105 11.9881 2.82105 11.9881 4.54737V17.6842ZM24.0281 9.46316C24.0281 9.46316 23.997 9.49474 23.9867 9.49474C23.8104 9.66316 23.5822 9.7579 23.3437 9.7579H23.3126C23.0741 9.74737 22.8356 9.64211 22.6696 9.46316L18.6978 5.43158C18.5111 5.24211 18.4178 5 18.4178 4.73684V2.31579C18.4178 1.98947 18.5319 1.66316 18.7289 1.41053C18.76 1.35789 18.8015 1.30526 18.843 1.26316H18.8533C19.123 0.978947 19.4963 0.821053 19.88 0.821053H22.2652C22.5244 0.821053 22.763 0.926316 22.9393 1.10526L24.3496 2.53684L24.9615 3.16842L26.9111 5.14737C27.0978 5.33684 27.2015 5.57895 27.2015 5.84211C27.2015 6.10526 27.0978 6.34737 26.9111 6.53684L24.0281 9.46316ZM12.9733 4.52632H12.9837C12.9837 2.8 14.3526 1.41053 16.043 1.41053H17.7956C17.6711 1.69474 17.6089 2 17.6089 2.31579V4.73684C17.6089 5.21053 17.7956 5.66316 18.1274 6.01053L22.0993 10.0421C22.1719 10.1158 22.2548 10.1895 22.3378 10.2421V16.3895H17.9407C16.1985 16.3895 14.4978 16.8316 12.9733 17.6842V4.52632ZM23.9867 18.0632H21.8089C19.1541 18.0632 16.4889 18.3684 13.8963 18.9789C13.8444 18.9895 13.7822 19 13.72 19C13.5022 19 13.2948 18.8947 13.1496 18.7263C14.6015 17.8421 16.2607 17.3789 17.9511 17.3789H22.8252C23.0948 17.3789 23.3126 17.1579 23.3126 16.8842V10.5684H23.3437C23.5719 10.5684 23.7793 10.5263 23.9867 10.4421V18.0632Z"                      fill="#333333"                    />                    <path                      d="M19.5481 1.46316C19.4133 1.46316 19.2785 1.51579 19.1852 1.61053C19.0919 1.70526 19.04 1.83158 19.04 1.97895C19.04 2.11579 19.0919 2.24211 19.1852 2.33684C19.2785 2.43158 19.4133 2.48421 19.5481 2.48421C19.683 2.48421 19.8074 2.43158 19.9007 2.33684C19.9941 2.24211 20.0459 2.11579 20.0459 1.97895C20.0459 1.83158 20.0044 1.70526 19.9007 1.61053C19.8074 1.51579 19.683 1.46316 19.5481 1.46316Z"                      fill="#333333"                    />                    <path                      d="M24.08 3.47368C24.08 3.47368 24.0178 3.44211 23.9867 3.44211C23.9244 3.41053 23.8726 3.38947 23.8104 3.37895C23.6548 3.33684 23.4889 3.31579 23.3126 3.31579H23.24C22.8667 3.33684 22.5659 3.44211 22.3378 3.66316C22.317 3.66316 22.2963 3.69474 22.2756 3.71579C22.0267 3.96842 21.8711 4.30526 21.7985 4.71579H21.6015C21.477 4.71579 21.3733 4.82105 21.3733 4.95789C21.3733 5.09474 21.477 5.18947 21.6015 5.18947H21.7467V5.48421H21.6015C21.477 5.48421 21.3733 5.57895 21.3733 5.71579C21.3733 5.85263 21.477 5.95789 21.6015 5.95789H21.7985C21.8815 6.35789 22.0474 6.67368 22.2859 6.91579C22.2963 6.92632 22.317 6.94737 22.3378 6.95789C22.5763 7.17895 22.9081 7.29474 23.3126 7.29474H23.323C23.4889 7.29474 23.6444 7.27368 23.7793 7.24211C23.8519 7.22105 23.9244 7.21053 23.9867 7.17895C23.997 7.17895 24.0074 7.16842 24.0178 7.16842C24.1215 7.13684 24.1837 7.03158 24.1837 6.92632C24.1837 6.8421 24.1526 6.76842 24.0904 6.71579C24.0593 6.69474 24.0178 6.67368 23.9867 6.67368C23.9452 6.66316 23.9037 6.66316 23.8622 6.67368C23.8207 6.68421 23.7793 6.69474 23.7378 6.70526C23.6133 6.73684 23.4785 6.74737 23.3437 6.74737H23.3126C23.0533 6.73684 22.8459 6.66316 22.7007 6.52632C22.5556 6.37895 22.4519 6.18947 22.3896 5.94737H23.2607C23.2607 5.94737 23.2919 5.94737 23.3126 5.93684C23.4163 5.91579 23.4993 5.82105 23.4993 5.71579C23.4993 5.6 23.4163 5.50526 23.3126 5.48421C23.2919 5.47368 23.2815 5.47368 23.2607 5.47368H22.3378V5.18947H23.4163C23.5407 5.18947 23.6548 5.09474 23.6548 4.95789C23.6548 4.82105 23.5407 4.71579 23.4163 4.71579H22.3896C22.5244 4.13684 22.8148 3.85263 23.3022 3.85263H23.3126C23.437 3.85263 23.5615 3.87368 23.6859 3.91579C23.7378 3.93684 23.8 3.96842 23.8622 3.98947C23.9037 4.01053 23.9452 4.01053 23.9867 3.98947C24.0696 3.98947 24.1422 3.93684 24.1837 3.86316L24.2044 3.82105C24.2356 3.75789 24.2459 3.68421 24.2252 3.62105C24.1941 3.54737 24.1422 3.48421 24.08 3.46316V3.47368Z"                      fill="#333333"                    />                  </g>                  <defs>                    <clipPath id="clip0_1014_216">                      <rect width="28" height="20" fill="white" />                    </clipPath>                  </defs>                </svg>
              </span>
              <span v-if="training.rented" class="white">
                {{toLocal('generic.rented')}}
                <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1014_216)">
                  <path d="M27.4815 4.56842L23.5096 0.526316C23.1778 0.189474 22.7319 0 22.2652 0H19.88C19.4133 0 18.9674 0.147368 18.5837 0.410526H16.043C15.2859 0.410526 14.5496 0.631579 13.9067 1.03158C13.3052 1.41053 12.8178 1.93684 12.4859 2.56842C12.1437 1.93684 11.6563 1.41053 11.0652 1.03158C10.4222 0.631579 9.67556 0.410526 8.92889 0.410526H2.14667C1.87704 0.410526 1.65926 0.642105 1.65926 0.905263V16.8947C1.65926 17.1684 1.87704 17.3895 2.14667 17.3895H7.02074C8.70074 17.3895 10.36 17.8526 11.8119 18.7368C11.6667 18.9158 11.4489 19.0105 11.2311 19.0105C11.1793 19.0105 11.1274 19 11.0652 18.9895C8.47259 18.3789 5.81778 18.0737 3.15259 18.0737H0.985185V3.02105C0.985185 2.74737 0.757037 2.51579 0.487407 2.51579C0.217778 2.51579 0 2.74737 0 3.02105V18.5789C0 18.8526 0.228148 19.0737 0.487407 19.0737H3.15259C5.74518 19.0737 8.32741 19.3684 10.8474 19.9579C10.9822 19.9895 11.1067 20 11.2415 20C11.7185 20 12.1644 19.8105 12.4859 19.4632C12.8074 19.8105 13.2533 20 13.72 20C13.8548 20 13.9793 19.9895 14.1141 19.9579C16.6444 19.3684 19.2267 19.0632 21.8089 19.0632H24.4741C24.7437 19.0632 24.9615 18.8421 24.9615 18.5684V9.67368L27.4815 7.10526C27.8237 6.76842 28 6.31579 28 5.84211C28 5.36842 27.8237 4.90526 27.4815 4.56842ZM11.9881 17.6842C10.4637 16.8316 8.76296 16.3895 7.03111 16.3895H2.63407V1.41053H8.91852C10.6193 1.42105 11.9881 2.82105 11.9881 4.54737V17.6842ZM24.0281 9.46316C24.0281 9.46316 23.997 9.49474 23.9867 9.49474C23.8104 9.66316 23.5822 9.7579 23.3437 9.7579H23.3126C23.0741 9.74737 22.8356 9.64211 22.6696 9.46316L18.6978 5.43158C18.5111 5.24211 18.4178 5 18.4178 4.73684V2.31579C18.4178 1.98947 18.5319 1.66316 18.7289 1.41053C18.76 1.35789 18.8015 1.30526 18.843 1.26316H18.8533C19.123 0.978947 19.4963 0.821053 19.88 0.821053H22.2652C22.5244 0.821053 22.763 0.926316 22.9393 1.10526L24.3496 2.53684L24.9615 3.16842L26.9111 5.14737C27.0978 5.33684 27.2015 5.57895 27.2015 5.84211C27.2015 6.10526 27.0978 6.34737 26.9111 6.53684L24.0281 9.46316ZM12.9733 4.52632H12.9837C12.9837 2.8 14.3526 1.41053 16.043 1.41053H17.7956C17.6711 1.69474 17.6089 2 17.6089 2.31579V4.73684C17.6089 5.21053 17.7956 5.66316 18.1274 6.01053L22.0993 10.0421C22.1719 10.1158 22.2548 10.1895 22.3378 10.2421V16.3895H17.9407C16.1985 16.3895 14.4978 16.8316 12.9733 17.6842V4.52632ZM23.9867 18.0632H21.8089C19.1541 18.0632 16.4889 18.3684 13.8963 18.9789C13.8444 18.9895 13.7822 19 13.72 19C13.5022 19 13.2948 18.8947 13.1496 18.7263C14.6015 17.8421 16.2607 17.3789 17.9511 17.3789H22.8252C23.0948 17.3789 23.3126 17.1579 23.3126 16.8842V10.5684H23.3437C23.5719 10.5684 23.7793 10.5263 23.9867 10.4421V18.0632Z" fill="#333333"/>
                  <path d="M19.5481 1.46316C19.4133 1.46316 19.2785 1.51579 19.1852 1.61053C19.0919 1.70526 19.04 1.83158 19.04 1.97895C19.04 2.11579 19.0919 2.24211 19.1852 2.33684C19.2785 2.43158 19.4133 2.48421 19.5481 2.48421C19.683 2.48421 19.8074 2.43158 19.9007 2.33684C19.9941 2.24211 20.0459 2.11579 20.0459 1.97895C20.0459 1.83158 20.0044 1.70526 19.9007 1.61053C19.8074 1.51579 19.683 1.46316 19.5481 1.46316Z" fill="#333333"/>
                  <path d="M24.08 3.47368C24.08 3.47368 24.0178 3.44211 23.9867 3.44211C23.9244 3.41053 23.8726 3.38947 23.8104 3.37895C23.6548 3.33684 23.4889 3.31579 23.3126 3.31579H23.24C22.8667 3.33684 22.5659 3.44211 22.3378 3.66316C22.317 3.66316 22.2963 3.69474 22.2756 3.71579C22.0267 3.96842 21.8711 4.30526 21.7985 4.71579H21.6015C21.477 4.71579 21.3733 4.82105 21.3733 4.95789C21.3733 5.09474 21.477 5.18947 21.6015 5.18947H21.7467V5.48421H21.6015C21.477 5.48421 21.3733 5.57895 21.3733 5.71579C21.3733 5.85263 21.477 5.95789 21.6015 5.95789H21.7985C21.8815 6.35789 22.0474 6.67368 22.2859 6.91579C22.2963 6.92632 22.317 6.94737 22.3378 6.95789C22.5763 7.17895 22.9081 7.29474 23.3126 7.29474H23.323C23.4889 7.29474 23.6444 7.27368 23.7793 7.24211C23.8519 7.22105 23.9244 7.21053 23.9867 7.17895C23.997 7.17895 24.0074 7.16842 24.0178 7.16842C24.1215 7.13684 24.1837 7.03158 24.1837 6.92632C24.1837 6.8421 24.1526 6.76842 24.0904 6.71579C24.0593 6.69474 24.0178 6.67368 23.9867 6.67368C23.9452 6.66316 23.9037 6.66316 23.8622 6.67368C23.8207 6.68421 23.7793 6.69474 23.7378 6.70526C23.6133 6.73684 23.4785 6.74737 23.3437 6.74737H23.3126C23.0533 6.73684 22.8459 6.66316 22.7007 6.52632C22.5556 6.37895 22.4519 6.18947 22.3896 5.94737H23.2607C23.2607 5.94737 23.2919 5.94737 23.3126 5.93684C23.4163 5.91579 23.4993 5.82105 23.4993 5.71579C23.4993 5.6 23.4163 5.50526 23.3126 5.48421C23.2919 5.47368 23.2815 5.47368 23.2607 5.47368H22.3378V5.18947H23.4163C23.5407 5.18947 23.6548 5.09474 23.6548 4.95789C23.6548 4.82105 23.5407 4.71579 23.4163 4.71579H22.3896C22.5244 4.13684 22.8148 3.85263 23.3022 3.85263H23.3126C23.437 3.85263 23.5615 3.87368 23.6859 3.91579C23.7378 3.93684 23.8 3.96842 23.8622 3.98947C23.9037 4.01053 23.9452 4.01053 23.9867 3.98947C24.0696 3.98947 24.1422 3.93684 24.1837 3.86316L24.2044 3.82105C24.2356 3.75789 24.2459 3.68421 24.2252 3.62105C24.1941 3.54737 24.1422 3.48421 24.08 3.46316V3.47368Z" fill="#333333"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_1014_216">
                    <rect width="28" height="20" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>
              </span>
              <span v-if="training.data.time != 0 && type=='paid'" class=" paid">
                {{ getTrainingTime(training.data.time) }}
              </span>
              <span
                v-if="training.data.price == 0 && training.data.price_rent == 0 && type!='default'"
              >
               {{toLocal('training_shop.free')}}
              </span>
              <span
                v-if="training.price_from"
              >
               {{toLocal('training_shop.price_from')}} {{training.price_from.toString().replace('.',',')}} €
              </span>
            </div>
            <div
              class="play-button not--ended"
              @click="openTraining(training, training.id, training.rented)"
              v-if="training.user_training_status == 0 && (training.data ? training.data.trainingType != 'doc' : true)"
            >
              <HomeTrainingStartSvg />
            </div>
            <div
              class="play-button ended"
              @click="openTraining(training, training.id, training.rented)"
              v-if="training.user_training_status == 2 && (training.data ? training.data.trainingType != 'doc' : true)"
            >
              <HomeTrainingCompleteSvg />
            </div>
            <div
              class="play-button started"
              @click="openTraining(training, training.id, training.rented)"
              v-if="training.user_training_status == 1 && (training.data ? training.data.trainingType != 'doc' : true)"
            >
              <HomeTrainingContinueSvg />
            </div>
            <div
              class="cover"
              :class="{
                started: training.user_training_status == 1,
                ended: training.user_training_status == 2,
              }"
              :style="[
                training.data.cover != ''
                  ? {
                      'background-image': `url('${getCoverURL(training.data.cover, training.rented)}')`,
                    }
                  : {},
              ]"
              @click="openTrainingFunction != null ? openTrainingFunction(training) : openTraining(training, training.id, training.rented)"
            >
              <div class="overlay" v-if="type == 'paid'"></div>
              <div 
                class="title" 
                :class="{ 'paid-title': type == 'paid' }"
              >
                <h2 :style="getCardStyle(training)">{{ training.data.title }}</h2>
                <div class="slider" v-if="type != 'paid'">
                  <span v-if="training.data.time != 0" class="slider--time">
                    {{ getTrainingTime(training.data.time) }}
                  </span>
                  <div class="slider--bar">
                    <div class="slider--fill" style="width: 0%" />
                    <div class="slider--blob" />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="stats-btn"
              v-if="canViewStats() && $store.state.user_role == 'super'"
            >
              <span @click="trainingStats(training.id, training.rented)"
                >{{ training.rented }}
                <HomeTrainingStatisticsSvg class="stroke" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <HomeTrainingOverlay v-if="overlay.open" :data="overlay.data" @close="overlay.open=false"/>
  </section>
</template>

<script>
import axios from "axios";
import VueScrollTo from "vue-scrollto";
import _ from "lodash";
import { ObserveVisibility } from "vue-observe-visibility";
import HeaderButtons from "@/components/layout/HeaderButtons.vue";
import HomeTrainingOverlay from "@/components/layout/trainings/overlay/HomeTrainingOverlay.vue";

//SVG
import HomeSearchSvg from "@/assets/images/icons/home/home-search.svg?inline";
import HomeCancelSearchSvg from "@/assets/images/icons/home/home-cancel-search.svg?inline";
import HomeTrainingStartSvg from "@/assets/images/icons/home/home-training-start.svg?inline";
import HomeTrainingCompleteSvg from "@/assets/images/icons/home/home-training-complete.svg?inline";
import HomeTrainingContinueSvg from "@/assets/images/icons/home/home-training-continue.svg?inline";
import HomeTrainingStatisticsSvg from "@/assets/images/icons/home/home-statistics.svg?inline";
import GroupSearchSvg from "@/assets/images/icons/group-search-black.svg?inline";
import ArrowLeftSvg from "@/assets/images/icons/homeEdit/arrow-go-back-16-8.svg?inline";

export default {
  name: "Home",
  components: {
    HeaderButtons,
    HomeTrainingOverlay,
    //SVG COMPONENTS
    HomeSearchSvg,
    HomeCancelSearchSvg,
    HomeTrainingStartSvg,
    HomeTrainingCompleteSvg,
    HomeTrainingContinueSvg,
    HomeTrainingStatisticsSvg,
    GroupSearchSvg,
    ArrowLeftSvg,
  },
  props: {
    openTrainingFunction: {
      default: null,
    },
    type: {
      default: "default",
    },
  },
  data: function () {
    return {
      trainingGroups: [],
      trainingGroup: "",
      trainings: [],
      trainingsClone: [],
      searchTrainingGroups: [],
      loaded: false,
      searchCopy: "",
      searchTerm: "",
      isHeaderInView: true,
      overlay: {
        open: false,
        data: {
          
        }
      }
    };
  },
  directives: { ObserveVisibility },

  mounted() {
    this.loaded = false;
    if(this.$store.state.routeHistory && this.$store.state.routeHistory.length == 1){
      this.$store.state.isOnlyTrainingGroup=true;
    }
    setTimeout(() => {
      this.loadTrainings();
      if (this.$store.state.loading != null) {
        this.$store.state.loading.loadingStart();
      }
    }, 10);
    if(this.$store.state.currentTraining !=-1){
      this.$store.state.currentTraining = -1;
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    this.loaded = false;
    this.$store.state.homePageSearchInput = "";
    this.$store.state.homePageSearchLoaded = false;
    this.$store.state.showHomePageSearchInput = true;
  },
  watch: {
    "$store.state.homePageSearchInput"() {
      this.searchTrainingsInput();
    },
    loaded() {
      this.$store.state.homePageSearchLoaded = this.loaded;
    },
    '$route.query.id':{
      handler(){
        this.loaded = false;
        setTimeout(() => {
          this.loadTrainings();
          if (this.$store.state.loading != null) {
            this.$store.state.loading.loadingStart();
          }
        }, 10);
        if(this.$store.state.currentTraining !=-1){
          this.$store.state.currentTraining = -1;
        }
      }
    }
  },

  methods: {
    goBack() {
      this.$router.push("/");
    },
    handleScroll() {
      if (this.$refs["headerbuttons"] != undefined) {
        if (this.$refs["headerbuttons"].getBoundingClientRect().top >= 100) {
          this.isHeaderInView = true;
          this.$store.state.showingHeaderSearchBar = false;
        } else {
          this.isHeaderInView = false;
          this.$store.state.showingHeaderSearchBar = true;
        }
      }
    },

    loadTrainings() {
      if(!this.$store.state.currentGroupOpen && this.$route.query.id) this.$store.state.currentGroupOpen = this.$route.query.id;
      let request_link =
        this.openTrainingFunction != null
          ? `${this.$store.state.api_link}/training_group/paid_trainings`
          : `${this.$store.state.api_link}/training_group/user_training_groups/${this.$store.state.currentGroupOpen}`;

      axios
        .get(request_link, this.$store.getters.axiosConfig())
        .then((response) => {
          let temp = response.data;
          if (this.type == "paid") temp = { trainings: temp };
          if (temp == undefined) {
            this.$store.state.loading.loadingDone();
            return;
          }
          let trainingGroup = temp;
          trainingGroup["editingTitle"] = false;
          if( trainingGroup.trainings){
            trainingGroup.trainings.forEach((training) => {
              training.data = JSON.parse(training.data);
            });
            if (trainingGroup.assignedRented != undefined) {
              trainingGroup.assignedRented.forEach((training) => {
                training.data = JSON.parse(training.data);
              });
            }
            trainingGroup.trainings.sort((a, b) =>
              a.ended > b.ended
                ? 1
                : a.ended === b.ended
                ? a.weight > b.weight
                  ? 1
                  : -1
                : -1
            );
          }
          this.addingTraining = false;
          this.addingNewGroup = false;
          if (this.$store.state.loading != null)
            this.$store.state.loading.loadingDone();
          this.loaded = true;
          this.trainingGroup = trainingGroup;
          if (this.trainingGroup.assignedRented != undefined) {
            this.trainingGroup.trainings = this.trainingGroup.trainings.concat(
              this.trainingGroup.assignedRented
            );
          }
          this.trainings = this.trainingGroup.trainings;
          this.trainingsClone = _.cloneDeep(this.trainingGroup.trainings);
          VueScrollTo.scrollTo(`body`, 100);
          if (this.$store.state.loading != null)
            this.$store.state.loading.loadingDone();
          setTimeout(() => {
            this.loaded = true;
          }, 500);
        })
        .catch((error) => {
          console.log(error);
          if(this.$store.state.user_id == null || error.response.status == 401){
            if(!this.$route.query.order)
              this.$router.push("/login");
            this.$store.state.loading.loadingDone();
          }
      
          this.$store.commit("handleError", { error: error });
        });
    },
    loadTraining(id) {
      return axios
          .get(
            `${this.$store.state.api_link}/training/info/${id}?edit=true`,
            this.$store.getters.axiosConfig()
          );
    },
    openTraining(training, id, rentedStatus) {
      this.$store.state.loading.loadingStart();
      this.$store.state.currentTraining = id;
      this.$store.state.previewMode = false;
      let query = '?id='+id;
      if (rentedStatus != undefined && rentedStatus == 1) {
        this.$store.state.currentTrainingRented = true;
        query += '&rented=1';
      } else {
        this.$store.state.currentTrainingRented = false;
      }
      this.$store.state.previewTopic = -1;
      if (training && training.data && ['scorm','singleDoc'].includes(training.data.trainingType)) {
          this.$store.state.currentTraining = id;
         this.loadTraining(id).then((response) => {
          let data = JSON.parse(response.data.data);
          let index = [0, 0];
           let item = null
           if (training.data.trainingType == 'scorm') {

             index[0] = data.content.findIndex(el => {
               index[1] = el.items.findIndex(item => item.type == 'scorm')
               if (index[1] != -1) {
                 item = el.items[index[1]];
               }
               return index[1] != -1
             })
             if (item) {
               this.overlay.data.item = item;
               this.overlay.data.training = this.$store.state.currentTraining;
             }
           }
           else if (training.data.trainingType == 'singleDoc') {
            item = data.content[0].items[0];
            if (item) {
              this.overlay.data.item = item;
              this.overlay.data.training = data;
            }
           }

          this.overlay.open = true;

          this.$store.state.loading.loadingDone();
        });

      }
      else {
        this.$router.push("/training" + query);
      }
    },
    searchTrainingsInput(event) {
      this.searchTrainings(event, this);
    },
    getCardStyle(training) {
      let style = {};
      if (this.$store.state.system_settings.custom_style && this.$store.state.system_settings.custom_style.training_card_style && this.$store.state.system_settings.custom_style.training_card_style) { 
      if (this.$store.state.system_settings.custom_style.training_card_style['font-weight']) {
          style['font-weight'] = this.$store.state.system_settings.custom_style.training_card_style['font-weight'];
        }
      }
      return style;
    },
    searchTrainings: _.debounce((event, self) => {
      if (self.searchTerm != "") {
        self.trainingGroup.trainings = self.trainingsClone.filter(
          (training) =>
            training.data &&
            training.data.title &&
            training.data.title != null &&
            training.data.title
              .toLowerCase()
              .includes(self.searchTerm.toLowerCase())
        );
      } else {
        self.trainingGroup.trainings = self.trainingsClone;
      }
      if (self.trainingGroup.trainings.length == 0) {
        return false;
      } else {
        return true;
      }
    }, 10),
    trainingStats(id, rentedStatus) {
      this.$store.state.loading.loadingStart();
      if (rentedStatus != undefined && rentedStatus == 1) {
        this.$store.state.currentTrainingRented = true;
      } else {
        this.$store.state.currentTrainingRented = false;
      }
      this.$store.state.currentTraining = id;
      this.$router.push("/training-stats");
    },
    searchVisibilityChanged(e) {
      if (this.$store.state.homePageSearchLoaded)
        this.$store.state.showHomePageSearchInput = e;
    },
    getTrainingTime(time) {
      let minutes = time;
      let hours = Math.floor(minutes / 60);
      minutes = minutes % 60;
      return hours > 0 ? hours + " val. " + minutes + " min" : minutes + " min";
    },
    getCoverURL(cover, rented){
      if(this.type=='paid' || rented==1){
        let protocol = this.$store.state.ssl ? 'https://' : 'http://';
        return protocol +  process.env.VUE_APP_PARENT_LMS_API + '/uploads/' + cover;
      }
      else{
        return this.getFileUrl(cover)
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/views/_homeViewScoped.scss";
.paid,
.slider--free {
  position: absolute;
  padding: 8px 12px 7px 16px;
  background: var(--secondary-color);
  color: var(--primary-color);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.16);
  border-radius: 0px 20px 20px 0px;
  top: 16px;
  line-height: 24px;
  font-size: 16px;
  z-index: 2;
}
.slider--free {
  top: 65px;
}
.main--container .cards .card {
  .paid-title {
    padding: 16px;
    font-size: 20px;
    padding-top: 60px;
    line-height: 28;
    color: var(--primary-color);
    background: none;
  }
  &.fade{
    opacity: 0.7;
  }
}
.overlay {
  background: linear-gradient(
    180deg,
    rgba(239, 239, 239, 0) 0%,
    rgba(245, 245, 245, 0.8) 39.9%,
    rgba(255, 255, 255, 0.9) 100%
  );
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
}
.tag-container {
  position: absolute;
  top: 16px;
  left: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 8px;
  span {
    position: relative;
    padding: 8px 12px 7px 16px;
    background: var(--secondary-color);
    color: var(--primary-color);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.16);
    border-radius: 0px 20px 20px 0px;
    top: initial;
    line-height: 24px;
    font-size: 16px;
    width: fit-content;
    &.white {
      display: flex;
      align-items: center;
      svg {
        margin-left: 11px;
      }
      background: white;
    }
  }
}
</style>
